module.exports = __webpack_public_path__ + "static/media/add_user.4b658d6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add_user.svg
// module id = 2090
// module chunks = 0